//本文件IT之家小程序与辣品小程序通用，每次修改需同步一份
//fromApp用于代码中判断当前App，需要修改此值：lapin或ithome
var fromApp = 'lapin'
function parse(src, aTagAttr = {}) {
  var result = {}
  result.ismp = false
  result.mpurl = isEmpty(src) ? '' : src
  result.mpname = ''
  result.mpid = ''
  result.mpisself = true
  result.mppath = ''
  result.mpversion = 'release'
  result.isJd = false
  result.mpclass = 'mp-link'
  if (isEmpty(src)) {
    return result
  }
  if (typeof aTagAttr == typeof undefined) {
    aTagAttr = {}
  }
  var ithomepath = ''
  var lapinpath = ''
  var jdpath = ''
  var pddpath = ''
  if (
    src.toLowerCase().indexOf('ithome://openmp') == 0 ||
    src.toLowerCase().indexOf('lapin://openmp') == 0
  ) {
    // 一、小程序协议链接
    result.ismp = true
    var paraString = src.substring(src.indexOf('?') + 1, src.length).split('&')
    for (var i in paraString) {
      var keyvalue = paraString[i]
      var key = keyvalue.substring(0, keyvalue.indexOf('='))
      var value = keyvalue.substring(keyvalue.indexOf('=') + 1)
      if (key == 'appid') {
        result.mpname = value
      } else if (key == 'path') {
        if (!isEmpty(value) && value.indexOf('/') == 0) {
          value = value.substring(1)
        }
        result.mppath = decodeURIComponent(value)
      } else if (key == 'type') {
        result.mpversion = value
      } else if (key == 'spreadurl') {
        result.jdspreadurl = decodeURIComponent(value)
      } else if (key == 'wareid') {
        result.jdwareid = value
      }
    }
    if (
      result.mpname == 'ithome' ||
      result.mpname == 'gh_51364df95bb8' ||
      result.mpname == 'gh_b542d258a040' ||
      isEmpty(result.mpname)
    ) {
      // IT之家小程序
      // result.mpid = "wxc9091fcc9a6e550c";//这是老的ID之家小程序，已废弃
      result.mpname = 'gh_b542d258a040'
      result.mpid = 'wx8869812e2ddf7133'
      result.mpisself = fromApp === 'ithome'
    } else if (result.mpname == 'lapin' || result.mpname == 'gh_3aa4fec96d8c') {
      // 辣品小程序
      result.mpid = 'wx23a794697c395297'
      result.mpisself = fromApp === 'lapin'
    } else if (result.mpname == 'jd' || result.mpname == 'gh_45b306365c3d') {
      // 京东小程序
      result.mpid = 'wx91d27dbf599dff74'
      result.mpisself = false
      result.isJd = true
      if (
        isEmpty(result.mppath) &&
        !isEmpty(result.jdspreadurl) &&
        !isEmpty(result.jdwareid)
      ) {
        var customerinfo = fromApp === 'ithome' ? 'itzj180413' : 'lp180413'
        result.mppath =
          'pages/union/proxy/proxy?spreadUrl=' +
          encodeURIComponent(result.jdspreadurl) +
          '&customerinfo=' +
          customerinfo
      }
    } else if (
      result.mpname == 'pinduoduo' ||
      result.mpname == 'gh_0e7477744313'
    ) {
      // 拼多多小程序
      result.mpid = 'wx32540bd863b27570'
      result.mpisself = false
    } else if (result.mpname == 'jdgw' || result.mpname == 'gh_45b306365c3d') {
      // 京东购物
      result.mpid = 'wx91d27dbf599dff74'
      result.mpisself = false
    } else if (result.mpname.indexOf('wx') === 0) {
      // 其他直接传appid的小程序
      result.mpid = result.mpname
      result.mpisself = false
    } else {
      // 默认是自己
      if (fromApp === 'ithome') {
        // result.mpid = "wxc9091fcc9a6e550c";
        result.mpid = 'wx8869812e2ddf7133'
      } else if (fromApp === 'lapin') {
        result.mpid = 'wx23a794697c395297'
      }
      result.mpisself = true
    }
    result.mppath = (result.mpisself ? '/' : '') + result.mppath
  } else if (
    !isEmpty(aTagAttr.data_jdid) &&
    !isEmpty(src) &&
    src.toLowerCase().indexOf('.jd.com') > 0
  ) {
    // 二、约定的京东链接，含data-jdid属性的A标签
    var customerinfo = fromApp === 'ithome' ? 'itzj180413' : 'lp180413'
    // var wareId = aTagAttr.data_jdid;
    jdpath =
      'pages/union/proxy/proxy?spreadUrl=' +
      encodeURIComponent(src) +
      '&customerinfo=' +
      customerinfo
  } else if (aTagAttr.data_linktoken == 'pinduoduo') {
    // 三、约定的拼多多链接，含data-linktoken="pinduoduo"属性的A标签
    pddpath = src
    var userId = 0;//Taro.getApp().globalData.userinfo.userid
    if (userId > 0) {
      if (pddpath.indexOf('?') !== -1) {
        pddpath += '&customParameters=' + userId
      } else {
        pddpath += '?customParameters=' + userId
      }
    }
  } else if (aTagAttr.class == 'lplink' && isNumber(aTagAttr.data_id)) {
    lapinpath = 'pages/detail/lapinDetail?id=' + aTagAttr.data_id
  } else {
    // 四、其余链接，含IT之家、辣品内部链接
    if (
      src.indexOf('http://www.ithome.com/html/') == 0 ||
      src.indexOf('http://wap.ithome.com/html/') == 0 ||
      src.indexOf('https://www.ithome.com/html/') == 0 ||
      src.indexOf('https://wap.ithome.com/html/') == 0 ||
      src.indexOf('http://m.ithome.com/html/') == 0 ||
      src.indexOf('https://m.ithome.com/html/') == 0 ||
      src.indexOf('http://live.ithome.com/item/') == 0 ||
      src.indexOf('https://live.ithome.com/item/') == 0
    ) {
      // IT之家新闻(旧)、直播
      var end = src.indexOf('.htm', 20)
      var start = src.lastIndexOf('/', end)
      var newsid = src.substring(start + 1, end)
      if (isNumber(newsid)) {
        ithomepath = 'pages/detail/detail?newsid=' + newsid
        console.log('新闻ID:', newsid)
      }
    } else if (
      src.indexOf('http://www.ithome.com/zt/') == 0 ||
      src.indexOf('https://www.ithome.com/zt/') == 0
    ) {
      // IT之家专题页面
      var noParamUrl = removeQueryAndHash(src)
      var id = noParamUrl.substring(noParamUrl.indexOf('ithome.com/zt/') + 14)
      if (id.indexOf('/') > 0) {
        id = id.substring(0, id.indexOf('/'))
      }
      ithomepath = 'pages/detail/topic?id=' + id
    } else if (
      src.indexOf('https://www.ithome.com/') == 0 ||
      src.indexOf('http://www.ithome.com/') == 0
    ) {
      // IT之家新闻（新）
      if (src.indexOf('.htm') != -1) {
        var end = src.indexOf('.htm', 6)
        var id = src.substring(end - 10, end).replace(/\//g, '')
        if (isNumber(id)) {
          ithomepath = 'pages/detail/detail?newsid=' + parseInt(id)
        }
      }
    } else if (
      src.indexOf('http://quan.ithome.com/user/') == 0 ||
      src.indexOf('https://quan.ithome.com/user/') == 0
    ) {
      // 用户页面
      var noParamUrl = removeQueryAndHash(src)
      if (noParamUrl.endsWith('/')) {
        noParamUrl = noParamUrl.substring(0, noParamUrl.length - 1)
      }
      var userId = noParamUrl.substring(noParamUrl.lastIndexOf('/') + 1)
      ithomepath = 'pages/userPage/userPage?userid=' + userId
    } else if (
      src.indexOf('http://quan.ithome.com/') == 0 ||
      src.indexOf('http://quan.ithome.com/wap/') == 0 ||
      src.indexOf('https://quan.ithome.com/') == 0 ||
      src.indexOf('https://quan.ithome.com/wap/') == 0
    ) {
      // 帖子详情
      var end = src.indexOf('.htm', 6)
      var id = src.substring(end - 10, end).replace(/\//g, '')
      if (isNumber(id)) {
        ithomepath = 'pages/quan/detail/detail?postid=' + id
      }
    } else if (src.toLowerCase().indexOf('ithome://lapintopic') == 0) {
      var linkInfo = parasUrl(src)
      if (isNumber(linkInfo.params.id)) {
        // 辣品专题（暂时跳转到辣品小程序）
        lapinpath = 'pages/topic/topic?id=' + linkInfo.params.id
      }
    } else if (src.toLowerCase().indexOf('lapin://lapin365.com') == 0) {
      var linkInfo = parasUrl(src)
      if (isNumber(linkInfo.params.specialtopic)) {
        // 辣品专题（暂时跳转到辣品小程序）
        lapinpath = 'pages/topic/topic?id=' + linkInfo.params.specialtopic
      } else if (isNumber(linkInfo.params.productid)) {
        // 辣品商品详情页（暂时跳转到辣品小程序）
        lapinpath = 'pages/detail/lapinDetail?id=' + linkInfo.params.productid
      }
    } else if (src.toLowerCase().indexOf('lapinm://product') == 0) {
      // 辣品商城商品详情页（暂时跳转到辣品小程序）
      var linkInfo = parasUrl(src)
      if (isNumber(linkInfo.params.id)) {
        lapinpath = 'pages/detail/detail?id=' + linkInfo.params.id
      }
    }
  }
  if (!isEmpty(ithomepath)) {
    result.ismp = true
    result.mpname = 'gh_51364df95bb8'
    result.mpid = 'wxc9091fcc9a6e550c'
    result.mpisself = fromApp === 'ithome'
    result.mppath = fromApp === 'ithome' ? '/' + ithomepath : ithomepath
    result.mpurl =
      'ithome://openmp?appname=' +
      result.mpid +
      '&appid=' +
      result.mpname +
      '&path=' +
      encodeURIComponent(result.mppath)
    result.mpversion = 'release'
  } else if (!isEmpty(lapinpath)) {
    result.ismp = true
    result.mpname = 'gh_3aa4fec96d8c'
    result.mpid = 'wx23a794697c395297'
    result.mpisself = fromApp === 'lapin'
    result.mppath = fromApp === 'lapin' ? '/' + lapinpath : lapinpath
    result.mpurl =
      'ithome://openmp?appname=' +
      result.mpid +
      '&appid=' +
      result.mpname +
      '&path=' +
      encodeURIComponent(result.mppath)
    result.mpversion = 'release'
  } else if (!isEmpty(jdpath)) {
    result.ismp = true
    // result.mpname = "gh_60ba91d4e9ea";
    // result.mpid = "wx13e41a437b8a1d2e";
    result.mpname = 'gh_45b306365c3d'
    result.mpid = 'wx91d27dbf599dff74'
    result.mpisself = false
    result.mppath = jdpath
    result.mpurl =
      'ithome://openmp?appname=' +
      result.mpid +
      '&appid=' +
      result.mpname +
      '&path=' +
      encodeURIComponent(result.mppath)
    result.mpversion = 'release'
    result.isJd = true
  } else if (!isEmpty(pddpath)) {
    result.ismp = true
    result.mpname = 'gh_0e7477744313'
    result.mpid = 'wx32540bd863b27570'
    result.mpisself = false
    result.mppath = pddpath
    result.mpurl =
      'ithome://openmp?appname=' +
      result.mpid +
      '&appid=' +
      result.mpname +
      '&path=' +
      encodeURIComponent(result.mppath)
    result.mpversion = 'release'
  }
  if (result.mpisself) {
    // 内部跳转链接不显示小程序logo
    result.mpclass = ''
  }
  // console.log("链接解析:", result)
  return result
}
function isEmpty(str) {
  return isUndefineOrEmpty(str)
}

// 字符串是否不为空
function isUndefineOrEmpty(str) {
  return str === undefined || str === '' || str === null
}
function isNumber(value) {
  if (typeof value === 'object' || isUndefineOrEmpty(value)) {
    return false
  } else {
    return !Number.isNaN(Number(value))
  }
}

//pagePath前不要/
function getSchemeUrl(pagePath = '') {
  var result = 'ithome://openmp?appid=' + fromApp
  if (!isEmpty(pagePath)) {
    if (pagePath.indexOf('/') == 0) {
      pagePath = pagePath.substring(1)
    }
    result += '&path=' + encodeURIComponent(pagePath)
  }
  return result
}

/**
 * 从url中取出域名，hostname
 */
function getDomainFormUrl(url) {
  var domain = url.split('/')
  if (domain.length >= 2 && domain[2]) {
    domain = domain[2]
  } else {
    domain = ''
  }
  if (domain.indexOf('?') > 0) {
    domain = domain.split('?')[0]
  }
  return domain
}
function parasUrl(url) {
  var scheme = ''
  if (url.indexOf('://') > 0) {
    scheme = url.split('://')[0]
  }
  var domain = getDomainFormUrl(url)
  var params = {}
  var keyvalue = []
  var key = '',
    value = ''
  var paraString = url.substring(url.indexOf('?') + 1, url.length).split('&')
  console.log('parseUrl:', url, paraString)
  for (var i in paraString) {
    // keyvalue = paraString[i].split("=");
    var str = paraString[i]
    if (str.indexOf('=') > 0) {
      key = str.substring(0, str.indexOf('='))
      value = str.substring(str.indexOf('=') + 1)
      params[key] = value
    }
  }
  return {
    scheme: scheme,
    host: domain,
    params: params,
  }
}
function removeQueryAndHash(str) {
  var result = str
  if (result.indexOf('?') > 0) {
    result = result.substring(0, result.indexOf('?'))
  }
  if (result.indexOf('#') > 0) {
    result = result.substring(0, result.indexOf('#'))
  }
  return result
}
module.exports = {
  parse: parse,
  getSchemeUrl: getSchemeUrl,
}
